<template>
  <span>
    <i v-if="!task.discarded" class="material-icons pointer ml-1" data-toggle="modal" :data-target="'#' + taskAttachmentModalId(task)">attach_file</i>
    <div class="modal fade" :id="taskAttachmentModalId(task)" ref="vuemodal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Upload a File</h5>
            <button type="button" class="close btn" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
          </button>
          </div>
          <div class="modal-body">
            <iframe border=0 ref="attachmentIframe">
              <p>Error Loading Attachments</p>
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import api from "api";

export default {
  props: {
    task: {
      type: Object
    }
  },
  mounted() {
    $(this.$refs.vuemodal).on("show.bs.modal", this.loadAttachmentIframe)
  },
  methods: {
    taskAttachmentModalId(task){
      return 'task-attachment-modal' + task.id
    },
    loadAttachmentIframe(){
      this.$refs.attachmentIframe.src = this.taskAttachmentUrl(this.task);
    },
    taskAttachmentUrl(task){
      return '/api/tasks/' + task.id + '/edit'
    },
  }
}
</script>
